// extracted by mini-css-extract-plugin
module.exports = {"commonBtn":"styles_commonBtn__jVL9O","outlinedBtn":"styles_outlinedBtn__3903o"};